'use client';
import { useTranslation } from 'react-i18next';
import { Stack, Typography, useBreakpoints, useTheme } from '@monorepo/nova-ui';
import {
  defaultFooterConfig,
  defaultFooterConfigTTP,
  FooterIcon,
  MenuLink,
} from '@monorepo/types';
import { useFooterConfig } from '../../../api/queries/use-footer-config-queries';
import { useGetEnvironment } from '../../../hooks';
import { RenderFooterColumns } from './footer-columns';
import { RenderSocialIcons } from './footer-socials';
import {
  StyledFooter,
  StyledFooterMobileContent,
} from './styles/footer.styled';

export const Footer = () => {
  const theme = useTheme();
  const { isDesktop } = useBreakpoints();
  const { is5ers, isTtp } = useGetEnvironment();
  const { t } = useTranslation('hubCommon');

  const { data: footerConfig } = useFooterConfig();
  const defaultConfig = isTtp ? defaultFooterConfigTTP : defaultFooterConfig;
  const footerLinks: MenuLink[] = footerConfig?.links?.length
    ? footerConfig.links
    : defaultConfig.links;

  const footerIcons: FooterIcon[] = footerConfig?.icons?.length
    ? footerConfig.icons
    : defaultConfig.icons;

  const getCopyrightText = () => {
    if (is5ers)
      return `The5%ers / ${t('copyright')} © ${new Date().getFullYear()}`;
    if (isTtp) return `TTP / ${t('copyright')} © ${new Date().getFullYear()}`;
    return `${t('copyright')} © ${new Date().getFullYear()}`;
  };

  const copyright = (
    <Typography
      variant="body1"
      fontWeight={theme.typography.fontWeightRegular}
      color={theme.palette.text.main}
      letterSpacing={theme.typography.pxToRem(0.08)}
      sx={{
        mt: { xs: 8, md: 6 },
        mb: { xs: 12, md: 0 },
      }}
    >
      {getCopyrightText()}
    </Typography>
  );

  return (
    <StyledFooter className="footer" component="footer">
      {!isDesktop ? (
        <StyledFooterMobileContent>
          <RenderSocialIcons icons={footerIcons} />
          <RenderFooterColumns footerLinks={footerLinks} />
          {copyright}
        </StyledFooterMobileContent>
      ) : (
        <Stack
          sx={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            pt: 6,
            gap: { md: 4, xl: 6 },
          }}
        >
          <Stack
            direction="column"
            sx={{
              flex: { md: 1, xl: 1 },
            }}
          >
            <RenderSocialIcons icons={footerIcons} />
            {copyright}
          </Stack>
          <Stack
            sx={{
              flex: { md: 2, xl: 1 },
            }}
          >
            <RenderFooterColumns footerLinks={footerLinks} />
          </Stack>
        </Stack>
      )}
    </StyledFooter>
  );
};
